import { Injectable, OnDestroy } from '@angular/core';
import { Http } from '@angular/http';

import { CONFIG } from 'app/config/config';
import { Session } from 'app/shared/services/session/session.service';
import { Test } from '../models';

@Injectable()
export class TestsService implements OnDestroy {
  practiceTests: Test[];
  exams: Test[];

  constructor(private _http: Http, private _session: Session)  { }

  getAllPracticeTests() : Promise<Test[]> {
    if (this.practiceTests) return Promise.resolve(this.practiceTests);
    else return this._http.get(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + '/practice_tests', { headers: this._session.headers() })
    .toPromise()
    .then(data => {
      let testJson: any[] = data.json();
      this.practiceTests = testJson.map(test => {
        test.type = 'practice_test';
        return new Test(test);
      });
      this.sortTests(this.practiceTests);
      return this.practiceTests;
    });
  }

  getAllExams() : Promise<Test[]> {
    if (this.exams) return Promise.resolve(this.exams);
    else return this._http.get(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + '/exams', { headers: this._session.headers() })
    .toPromise()
    .then(data => {
      let examJson: any[] = data.json();
      this.exams = examJson.map(exam => {
        exam.type = 'test';
        return new Test(exam);
      });
      this.sortTests(this.exams);
      return this.exams;
    });
  }

  getAllPracticeTestsAndExams(clearCache?: boolean) : Promise<Test[]> {
    if (clearCache) {
      this.practiceTests = null;
      this.exams = null;
    }
    if (this.practiceTestsAndExams) return Promise.resolve(this.practiceTestsAndExams);
    else return this.getAllPracticeTests()
    .then(() => {
      return this.getAllExams();
    })
    .then(() => {
      this.sortTests(this.practiceTestsAndExams);
      return this.practiceTestsAndExams;
    });
  }

  get practiceTestsAndExams() : Test[] {
    if (!this.exams || !this.practiceTests) return null;
    else return this.sortTests(this.exams.concat(this.practiceTests));
  }

  deleteTest(type: string, id: string | number) {
    let endpoint = type === 'test' ? '/exams' : '/practice_tests';
    return this._http.delete(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + endpoint + '/' + id,
    { headers: this._session.headers() })
    .toPromise()
    .then(() => {
      return this.getAllPracticeTestsAndExams(true);
    });
  }

  createExamOrPracticeTest(test: Test) : Promise<any> {
    return this._http.post(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + this.getEndpointForTest(test),
    test.toJson(), { headers: this._session.headers() })
    .toPromise()
    .then(() => {
      return this.getAllPracticeTestsAndExams(true);
    });
  }

  saveEditedTest(updatedTest: Test) : Promise<any> {
    if (updatedTest.id) {
      return this._http.put(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + this.getEndpointForTest(updatedTest) + '/' + updatedTest.id,
      updatedTest.toJson(), { headers: this._session.headers() })
      .toPromise()
      .then(() => {
        return this.getAllPracticeTestsAndExams(true);
      });
    } else return Promise.reject(null);
  }

  sortTests(tests: Test[]) {
    return tests.sort((a: Test, b: Test) => <any>b.lastModified - <any>a.lastModified);
  }

  getTest(id: number | string, testType: string) : Promise<Test> {
    let test: Test;
    let examPromise = testType === 'test' ? this.getAllExams() : this.getAllPracticeTests();
    return examPromise
    .then((tests: Test[]) => {
      test = tests.filter(test => test.id == id)[0];
      if (test) return this.getQuestionsForTest(test);
    })
    .then((data: any) => {
      if (data) {
        let questionJson: any = data.json();
        test.updateTestQuestionsWithJson(questionJson);
      }
      return test;
    });
  }

  // returns exam title but no other information
  getTestTitleById(id: number | string, testType: string): Promise<string> {
    return this.getTest(id, testType)
    .then((test: Test) => {
      return test.title;
    });
  }

  getQuestionsForTest(test: Test) : Promise<any> {
    return this._http.get(CONFIG.ENDPOINT_URL + '/apps/' + this._session.selectedAppSysName + this.getEndpointForTest(test) + '/' + test.id + '/questions', { headers: this._session.headers()})
          .toPromise();
  }

  getEndpointForTest(test: Test) {
    return test.type === 'test' ? '/exams' : '/practice_tests';
  }

  ngOnDestroy() {

  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/helpers/tests.service.ts